import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';

const UPDATE_PROJECT_MUTATION = gql`
  mutation UpdateProject(
    $id: ID!
    $name: String
    $address: String
    $startDate: ISO8601Date
    $endDate: ISO8601Date
    $paymentMethod: String
    $hasConstructionTracking: Boolean
    $hasAdhocTracking: Boolean
    $internalNotes: String
    $status: ProjectStatus
  ) {
    updateProject(
      id: $id
      name: $name
      address: $address
      startDate: $startDate
      endDate: $endDate
      paymentMethod: $paymentMethod
      hasConstructionTracking: $hasConstructionTracking
      hasAdhocTracking: $hasAdhocTracking
      internalNotes: $internalNotes
      status: $status
    ) {
      project {
        id
        name
        address
        startDate
        endDate
        paymentMethod
        hasConstructionTracking
        hasAdhocTracking
        internalNotes
        status
        updatedAt
      }
    }
  }
`;

interface UpdateProjectInput {
  id: string;
  name?: string;
  address?: string;
  startDate?: string;
  endDate?: string;
  paymentMethod?: string;
  hasConstructionTracking?: boolean;
  hasAdhocTracking?: boolean;
  internalNotes?: string;
  status?: string;
}

export function useUpdateProject() {
  const [updateProjectMutation, { loading, error }] = useMutation(UPDATE_PROJECT_MUTATION);

  const updateProject = async (input: UpdateProjectInput) => {
    const { data } = await updateProjectMutation({
      variables: input,
    });
    return (data as any)?.updateProject?.project;
  };

  return { updateProject, loading, error };
}